<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let btnText = "Weiter";
  export let flexibleHeight = false;
  export let btnDisabled = false;

</script>

<footer class:flexibleHeight={flexibleHeight} class="footer mt-auto py-3 fixed-bottom">
  <div class="container">
    <slot></slot>
    <button on:click={() => {dispatch("btnClicked")}} class:btnDisabled={btnDisabled} class="btn btn-specialOrange">{btnText}</button>
  </div>
</footer>

<style>
  button {
    filter: grayscale(0);
    transition: filter 0.5s ease-in-out;
  }

  .btnDisabled {
    filter: grayscale(1);
    cursor: not-allowed;
  }

  footer {
    background: #63b4d1;
    box-shadow: 0 -6px 30px rgb(103 102 102 / 40%);
    color: #fff;
    height: 120px;
  }

  .flexibleHeight {
    height: 80px;
  }
  .flexibleHeight button {
    margin-top: 0px;
  }

  footer > div.container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
</style>
